/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bioMatrixScanDetail.vue?vue&type=template&id=59736670&scoped=true"
import script from "./bioMatrixScanDetail.vue?vue&type=script&lang=js"
export * from "./bioMatrixScanDetail.vue?vue&type=script&lang=js"
import style0 from "./bioMatrixScanDetail.vue?vue&type=style&index=0&id=59736670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59736670",
  null
  
)

export default component.exports